import { call, put, takeLatest } from 'redux-saga/effects';
import { Companies } from 'services/api';
import {
  updateEmployee,
  updateEmployeeSuccess,
  updateEmployeeFailure,
  getEmployees,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* updateEmployeeSaga({ payload }) {
  try {
    const data = yield call(
      Companies.updateUser,
      payload.companyId,
      payload.userId,
      { company: payload.company }
    );
    yield put(updateEmployeeSuccess(data));
    yield put(getEmployees(payload.companyId));
    yield put(
      notificationActions.addNotification([
        { type: 'success', message: { code: 'saved', resource: 'changes' } },
      ])
    );
  } catch (e) {
    yield put(updateEmployeeFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(updateEmployee, updateEmployeeSaga);
